import { httpClient as s } from "../../httpClient.js";
class r {
  async updateOnboarding(e) {
    return (await s.put("/users/current-user/onboarding", e)).data;
  }
  async uploadOnboardingFile(e) {
    const n = new FormData();
    return n.append("file", e.file), (await s.post(
      `/users/current-user/images/${e.index}/${e.studentId}`,
      n
    )).data;
  }
  async deleteOnboardingFile(e) {
    return (await s.delete(
      `/users/current-user/images/${e.index}/${e.studentId}`
    )).data;
  }
}
const i = new r();
export {
  i as default
};
